import { Store } from 'vuex'
import { IApp } from '@/types/nuxt'
import { ICardProps } from '@/entities/Card'
import { RootState } from '@/store'
import * as types from '@/store/payment/types'
import SearchCardUseCase from '@/usecases/gmo/SearchCardUseCase'

export default class PaymentRepository {
  private store: Store<RootState>

  constructor(store: Store<RootState>) {
    this.store = store
  }

  set data(value: ICardProps[] | null) {
    this.store.commit(new types.Fetch(value))
  }

  get data(): ICardProps[] | null {
    return this.store.state.payment.cards
  }

  set error(value: unknown) {
    this.store.commit(new types.Error(value))
  }

  get error(): unknown {
    return this.store.state.payment.error
  }

  async fetch(app: IApp) {
    try {
      const cards = await new SearchCardUseCase(app).execute()
      // TODO: SearchCardResponseとICardPropsの型の不一致を是正する
      this.store.commit(new types.Fetch(cards as any))
    } catch (e) {
      this.store.commit(new types.Error(e))
    }
  }
}
